export default __webpack_public_path__ + "static/what-we-do-bg-8c6b8c86dbb35abd50673eb247f13b2a.jpg";